/**
 * Aviva Smart Solutions theme — small site-wide behaviors.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var menuToggle = document.querySelector('.menu-toggle');
    var mainNav = document.querySelector('.main-navigation');

    if (menuToggle && mainNav) {
      menuToggle.addEventListener('click', function () {
        mainNav.classList.toggle('toggled');
        var isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', String(!isExpanded));
      });
    }

    /**
     * PM Surya Ghar countdown (solar-subsidy page). Lives here, not in page
     * content, because Shopify's Page editor strips <script> tags AND any
     * data-* attributes on every save — so this depends only on class names
     * and DOM position, which survive.
     */
    var pmsgCountdown = document.querySelector('.pmsg-countdown');
    if (pmsgCountdown) {
      var pmsgTarget = new Date('2027-03-31T23:59:59+05:30').getTime();
      var pmsgUnits = pmsgCountdown.querySelectorAll('.pmsg-countdown-unit strong');
      var daysEl = pmsgUnits[0];
      var hoursEl = pmsgUnits[1];
      var minsEl = pmsgUnits[2];
      var secsEl = pmsgUnits[3];

      if (daysEl && hoursEl && minsEl && secsEl) {
        (function () {
          function pad(n) { return n < 10 ? '0' + n : '' + n; }

          function tick() {
            var diff = pmsgTarget - new Date().getTime();
            if (diff <= 0) {
              daysEl.textContent = '0';
              hoursEl.textContent = '00';
              minsEl.textContent = '00';
              secsEl.textContent = '00';
              clearInterval(timer);
              return;
            }
            daysEl.textContent = Math.floor(diff / 86400000);
            hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
            minsEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
            secsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
          }

          tick();
          var timer = setInterval(tick, 1000);
        })();
      }
    }
  });
})();
